import { render, staticRenderFns } from "./ResetPwdDialog.vue?vue&type=template&id=a610bd9a&scoped=true&"
import script from "./ResetPwdDialog.vue?vue&type=script&lang=js&"
export * from "./ResetPwdDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdDialog.vue?vue&type=style&index=0&id=a610bd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a610bd9a",
  null
  
)

export default component.exports